import firebase from "firebase";
export const getTeams = (uid) => async (dispatch) => {
  firebase
    .firestore()
    .collection("teams")
    .where("leader_id", "==", uid)
    .onSnapshot((data) => {
      var teams = [];
      data.docs.forEach((doc) => {
        teams.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_TEAMS",
        teams: teams,
      });
    });
};
